import React from 'react'
import MaterialSymbol from '../material-symbol'

const LocationOn = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="location_on" {...props} />
))

LocationOn.displayName = 'LocationOn'

export default LocationOn
